/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:55
 * @LastEditTime: 2022-07-03 00:32:06
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\enterprise\locales\zh-TW.ts
 */
export default {    
    'page.personal.center.compontent.enterprise.message' : '企業信息',
    'page.personal.center.compontent.enterprise.enterpriseName' : '企業名稱',
    'page.personal.center.compontent.enterprise.representative' : '法定代表人姓名',
    'page.personal.center.compontent.enterprise.creditCode' : '統一社會信用代碼',
    'page.personal.center.compontent.enterprise.validity' : '統一社會信用證有效期',
    'page.personal.center.compontent.enterprise.name' : '聯系人姓名',
    'page.personal.center.compontent.enterprise.email':'郵箱',
    'page.personal.center.compontent.enterprise.phone':'聯系電話',
    'page.personal.center.compontent.enterprise.address':'聯系地址',
    'page.personal.center.compontent.enterprise.addressMod':'詳細地址',
    'page.personal.center.compontent.enterprise.select':'請選擇',
    'page.personal.center.compontent.enterprise.businessLicense':'上傳公司營業執照掃描件',
    'page.personal.center.compontent.enterprise.size':'文件大小不超過6M',
    'page.personal.center.compontent.enterprise.support':'文件格式支持',
    'page.personal.center.compontent.enterprise.businessLicenseMod':'請上傳清晰可見的營業執照副本',
    'page.personal.center.compontent.enterprise.submit':'提交',
    'page.personal.center.compontent.enterprise.reset':'重置',

}
